/**
 * List all possible commands the system is capable of processing.
 */
export enum ReservationSkipOffersIfRuleChannelMaxChannelName {
  phone = 'phone',
}

export type ReservationSkipOffersIfRuleChannelMaxChannelType =
  keyof typeof ReservationSkipOffersIfRuleChannelMaxChannelName;
